import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { OrderSchemaType, ItemPath } from '../order.schema';
import { ApiItems } from '../types';

interface useItemAutofillProps {
  itemPath: ItemPath;
  itemOptionsFromApi: ApiItems[];
}

export const useItemsAutofill = ({ itemPath, itemOptionsFromApi }: useItemAutofillProps) => {
  const { watch, setValue } = useFormContext<OrderSchemaType>();

  const offeredProductMaterialPath = `${itemPath}.offeredProductMaterial` as const;
  const priceDetailsPath = `${itemPath}.priceDetails` as const;

  const selectedItemsName = watch(
    `${itemPath}.offeredProductMaterial.product`
  );

  const selectedItemNameString = Array.isArray(selectedItemsName)
    ? selectedItemsName[0]
    : selectedItemsName;

  useEffect(() => {
    if (!selectedItemNameString || itemOptionsFromApi.length === 0) {
      return;
    }

    const itemsData = itemOptionsFromApi.find(p => p.name === selectedItemNameString);

    if (itemsData) {
      setValue(
        `${itemPath}.offeredProductMaterial.ncm` as const,
        itemsData.ncm || '',
        { shouldDirty: true }
      );
      setValue(`${priceDetailsPath}.pricePerKgMin`, itemsData.costPerKg ?? 0, { shouldDirty: true });
      setValue(`${itemPath}.offeredProductMaterial.weigth` as const, itemsData.totalWeight ?? 'Auto', { shouldDirty: true });
    }
  }, [selectedItemNameString, itemOptionsFromApi, offeredProductMaterialPath, priceDetailsPath, setValue]);
};